module.exports = __webpack_public_path__ + "static/media/golden-time.139c5c6f.jpg";